export const INSTITUTE = {
  name: "Motion Mind Institute",
  shortName: "Motion Mind",
  tagline: "Learn. Create. Grow.",
  positioning: "Turn Your Creativity Into a Career.",
  address: "Asadullahpur Rohi, Bharwari, Kaushambi – 212201, Uttar Pradesh, India",
  addressShort: "Asadullahpur Rohi, Bharwari, Kaushambi – 212201",
  phoneDisplay: "9236670850",
  phoneTel: "+919236670850",
  email: "motionmindinstitute@gmail.com",
};

export const WA_NUMBER = "919236670850";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const WA_DEFAULT_MESSAGE =
  "Hello Motion Mind Institute, I would like to know more about your courses and admission process.";

export const WA_DEFAULT = waLink(WA_DEFAULT_MESSAGE);

export const SOCIALS = [
  { name: "Instagram", handle: "@motionmindinstitute", href: "https://instagram.com/motionmindinstitute" },
  { name: "Facebook", handle: "@motionmindinstitute", href: "https://facebook.com/motionmindinstitute" },
  { name: "YouTube", handle: "@motionmindinstitute", href: "https://youtube.com/@motionmindinstitute" },
];

export const COURSES = [
  {
    id: "graphic-design",
    num: "01",
    title: "Graphic Design",
    desc: "Learn the fundamentals of professional graphic design and create visually powerful designs for real-world use.",
    topics: [
      "Design fundamentals",
      "Typography",
      "Color theory",
      "Layout & composition",
      "Branding",
      "Social media design",
      "Poster design",
      "Promotional creatives",
      "Practical projects",
      "Portfolio development",
    ],
    image: "https://images.unsplash.com/photo-1621111848501-8d3634f82336?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Graphic design workstation with a creative desktop setup",
  },
  {
    id: "photoshop",
    num: "02",
    title: "Photoshop",
    desc: "Master Adobe Photoshop and learn how to create professional designs, photo manipulations and digital artwork.",
    topics: [
      "Photoshop fundamentals",
      "Layers",
      "Selection & masking",
      "Retouching",
      "Photo manipulation",
      "Typography",
      "Poster design",
      "Social media creatives",
      "Digital artwork",
      "Practical projects",
    ],
    image: "https://images.unsplash.com/photo-1744948961024-66baaafbb5dc?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Photo editing software open on a laptop screen",
  },
  {
    id: "video-editing",
    num: "03",
    title: "Video Editing",
    desc: "Learn professional video editing techniques and create engaging content for social media, YouTube and other digital platforms.",
    topics: [
      "Editing fundamentals",
      "Timeline & workflow",
      "Transitions",
      "Effects",
      "Color correction",
      "Audio editing",
      "Reels & short-form videos",
      "YouTube video editing",
      "Practical projects",
    ],
    image: "https://images.unsplash.com/photo-1619097647550-0fe7f031c18b?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Video editing timeline on a monitor in a dark studio",
  },
];

export const WHY_US = [
  {
    num: "01",
    title: "Practical Learning",
    desc: "Learn by creating real projects instead of only studying theory.",
    icon: "hammer",
  },
  {
    num: "02",
    title: "Beginner Friendly",
    desc: "Courses are designed to help beginners start confidently.",
    icon: "sprout",
  },
  {
    num: "03",
    title: "Hands-On Training",
    desc: "Practice creative tools and techniques through practical learning.",
    icon: "pointer",
  },
  {
    num: "04",
    title: "Portfolio Building",
    desc: "Create projects that can become part of your professional portfolio.",
    icon: "folder",
  },
  {
    num: "05",
    title: "Career-Focused Skills",
    desc: "Develop skills that can be useful for jobs, freelancing and personal projects.",
    icon: "trending",
  },
  {
    num: "06",
    title: "Creative Environment",
    desc: "Learn, experiment and improve in a focused creative environment.",
    icon: "bulb",
  },
];

export const PROCESS = [
  { num: "01", title: "Learn", desc: "Understand concepts, tools and techniques." },
  { num: "02", title: "Practice", desc: "Apply your knowledge through exercises and guided practice." },
  { num: "03", title: "Create", desc: "Work on practical and real-world creative projects." },
  { num: "04", title: "Grow", desc: "Build your portfolio, confidence and creative skills." },
];

export const GALLERY_CATEGORIES = [
  "Graphic Design",
  "Photoshop Artwork",
  "Posters",
  "Social Media Designs",
  "Thumbnails",
  "Branding",
  "Video Projects",
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1627244714766-94dab62ed964?crop=entropy&cs=srgb&fm=jpg&q=85";

export const WELCOME_IMAGE =
  "https://images.unsplash.com/photo-1761122912306-13d8f83892c1?crop=entropy&cs=srgb&fm=jpg&q=85";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1744686909443-eb72a54de998?crop=entropy&cs=srgb&fm=jpg&q=85";

export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const enquireAboutCourse = (course) => {
  window.dispatchEvent(new CustomEvent("mmi:enquire", { detail: course }));
  scrollToId("#contact");
};

export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
